import React from 'react';

interface DetailsLayoutProps {
  onBackClick: () => void;
  backButtonText?: string;
  children: React.ReactNode;
}

const DetailsLayout: React.FC<DetailsLayoutProps> = ({
  onBackClick,
  backButtonText = "← Back to Gallery",
  children
}) => {
  return (
    <div className="container mx-auto px-4 py-8">
      {/*<div className="mb-6">*/}
      {/*  <button */}
      {/*    onClick={onBackClick}*/}
      {/*    className="bg-gray-800 hover:bg-black text-white px-4 py-2 rounded-sm text-sm"*/}
      {/*  >*/}
      {/*    {backButtonText}*/}
      {/*  </button>*/}
      {/*</div>*/}
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {children}
      </div>
    </div>
  );
};

export default DetailsLayout;
